// get range type for the supplied date string.
export const getRangeType = (startDateStr, endDateStr) => {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  const dateDifferenceInDays =
    (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24);

  if (dateDifferenceInDays <= 7) {
    return 'Day';
  }
  if (dateDifferenceInDays <= 30) {
    return 'Week';
  }
  if (dateDifferenceInDays <= 90) {
    return 'Month';
  }

  const monthsDifference =
    (endDate.getFullYear() - startDate.getFullYear()) * 12 +
    (endDate.getMonth() - startDate.getMonth());

  if (monthsDifference < 36) {
    return 'Month';
  }

  return 'Year';
};
/**
 * convert Date Time to local format.
 * @param {*} inputDateStr
 * @returns {String}
 */
export const formatDateTime = (inputDateStr) => {
  if (!inputDateStr) {
    return '';
  }

  // Create a Date object from the input date string
  const date = new Date(inputDateStr);

  // Extract date parts
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const year = date.getFullYear();

  // Extract time parts
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  // Return the formatted date and time as MM-DD-YYYY HH:MM:SS
  return `${month}-${day}-${year} ${hours}:${minutes}:${seconds}`;
};

/**
 * Converts a JavaScript object to a Base64 encoded string
 * @param {Object} obj - The object to convert to Base64
 * @returns {string} Base64 encoded string representation of the object
 */
export const objectToBase64 = (obj) => {
  // Convert object to JSON string
  const jsonString = JSON.stringify(obj);
  return btoa(unescape(encodeURIComponent(jsonString)));
};

/**
 * Converts a Base64 encoded string back to a JavaScript object
 * @param {string} base64String - The Base64 string to convert
 * @returns {Object|boolean} The parsed JavaScript object, or false if conversion fails
 */
export const base64ToObject = (base64String) => {
  try {
    // Decode Base64 string to binary string
    const binaryString = atob(base64String);

    const jsonString = decodeURIComponent(escape(binaryString));

    // Parse JSON string back to JavaScript object
    return JSON.parse(jsonString);
  } catch (error) {
    // Return false if any error occurs during:
    // - Base64 decoding (atob)
    // - URI component decoding
    // - JSON parsing
    console.error('Error converting Base64 to object:', error);
    return false;
  }
};

export const logoutLocalSession = async () => {
    // Clear auth cookies and other storage
    deleteAllCookies();
    sessionStorage.clear();
    localStorage.clear();
    
    window.location.replace('/login');
  };

export default getRangeType;
